"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputSizesCSS = void 0;

var styled_components_1 = require("styled-components");

exports.InputSizesCSS = (0, styled_components_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  if (props.size === "xs") {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 0.8em;\n      ";
  }

  if (props.size === "sm") {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 0.8em;\n      ";
  }

  if (props.size === "md" || !props.size) {
    return "\n        padding: 0.8em 0.5em;\n        font-size: 1em;\n      ";
  }

  if (props.size === "lg") {
    return "\n        padding: 0.8em;\n        font-size: 1.2em;\n      ";
  }

  if (props.size === "xl") {
    return "\n        width: 100%;\n        padding: 0.8em 0.5em;\n        font-size: 1.6em;\n        text-align: center;\n      ";
  }

  return "\n      padding: 0.8em 0.5em;\n      font-size: 1.1em;\n    ";
});